export default {
  en: {
    actions: {
      event: 'Event',
      news: 'News',
      discussion: 'Discussion',
      engagement: 'Engagement',
      poll: 'Poll',
      date: 'Date finder',
      organize: 'Organize',
      group_post: 'Group Posts',
      forum_posts: 'Forum',
      subgroup: 'Subgroup',
      section: 'Section',
    },
  },
};
